import React from 'react'
import styled from 'styled-components'
import { getDmdAddress } from 'utils/addressHelpers'
import { DarkMatterRound } from '../../../components/Png'
import Text from '../../../components/Text/Text'
import Skeleton from '../../../components/Skeleton/Skeleton'
import Button from '../../../components/Button/Button'
import Flex from '../../../components/Box/Flex'

interface Props {
  dmdPriceUsd?: number
}

const PriceButton = styled(Button)<{ isFinished?: boolean; background?: string }>`
  height: 50px;
  padding: 0 16px;
  // background: linear-gradient(90deg, #c45bec, #9112ff);
  background: transparent;
`

const PriceLink = styled.a`
  svg {
    transition: transform 0.3s;
  }
  :hover {
    svg {
      transform: scale(1.2);
    }
  }
`

const PriceRoundTextWrapper = styled.div`
  // margin-right: 32px;
`

const DmdPrice: React.FC<Props> = ({ dmdPriceUsd }) => {
  return dmdPriceUsd ? (
    <PriceLink href={`https://info.spookyswap.finance/token/${getDmdAddress()}`} target="_blank">
      <PriceButton>
        <PriceRoundTextWrapper>
          <Flex alignItems="center">
            <DarkMatterRound w="15px" m="0 8px 0 0" />
            <Text color="text" fontSize="13px" fontWeight="300">{`$${dmdPriceUsd.toFixed(3)}`}</Text>
          </Flex>
        </PriceRoundTextWrapper>
      </PriceButton>
    </PriceLink>
  ) : (
    <Skeleton mr="12px" width={80} height={24} />
  )
}

export default React.memo(DmdPrice)
